(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileMenuOpen = document.getElementById('mobile-menu-open');
  const mobileMenuClose = document.getElementById('mobile-menu-close');
  const mobileMenuLinks = document.querySelectorAll('#mobile-menu a');

  mobileMenuOpen.addEventListener('click', () => {
    mobileMenu.classList.toggle('hidden');
  });

  mobileMenuClose.addEventListener('click', () => {
    mobileMenu.classList.toggle('hidden');
  });

  mobileMenuLinks.forEach((link) => {
    link.addEventListener('click', () => {
      document.getElementById('mobile-menu').classList.toggle('hidden');
    });
  });

  // Mobile menu scrolling
  // window.addEventListener('scroll', function () {
  //   const header = document.getElementById('header');
  //   const innerHeader = document.getElementById('inner-header');

  //   if (window.scrollY > 0) {
  //     // Add a class to the header when scrolling starts
  //     header.classList.add('bg-white', 'dark:bg-black', 'bg-opacity-80', 'dark:bg-opacity-80');
  //   } else {
  //     // Remove the class when scrolling back to the top
  //     header.classList.remove('bg-white', 'dark:bg-black', 'bg-opacity-80', 'dark:bg-opacity-80');
  //   }
  // });

  // // Theme switch
  const button = document.getElementById('theme-switch');
  const slider = button.querySelector('[aria-hidden="true"]');

  document.getElementById('theme-switch').addEventListener('click', () => {
    if (button.getAttribute('aria-checked') === 'false') {
      button.setAttribute('aria-checked', 'true');
      button.classList.remove('bg-gray-200');
      button.classList.add('bg-gradient-to-r', 'from-cyan-500', 'to-blue-500');
      slider.classList.replace('translate-x-0', 'translate-x-5');
    } else {
      button.setAttribute('aria-checked', 'false');
      button.classList.add('bg-gray-200');
      button.classList.remove('bg-gradient-to-r', 'from-cyan-500', 'to-blue-500');
      slider.classList.replace('translate-x-5', 'translate-x-0');
    }
  });

  // Set the theme switch based on the user's preference

  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    button.setAttribute('aria-checked', 'true');
    button.classList.remove('bg-gray-200');
    button.classList.add('bg-gradient-to-r', 'from-cyan-500', 'to-blue-500');
    slider.classList.replace('translate-x-0', 'translate-x-5');
  } else {
    button.setAttribute('aria-checked', 'false');
    button.classList.add('bg-gray-200');
    button.classList.remove('bg-gradient-to-r', 'from-cyan-500', 'to-blue-500');
    slider.classList.replace('translate-x-5', 'translate-x-0');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !window.DesignMode) return;
  try {
    
  Shopify.queryParams = {};

  // Preserve existing query parameters
  if (location.search.length) {
    var params = location.search.substr(1).split('&');

    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=');

      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      }
    }
  }

  // Update sort_by query parameter on select change
  document.querySelector('#sort-by').addEventListener('change', function (e) {
    var value = e.target.value;

    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });

  // Quick view

  var quickViewButton = document.querySelectorAll('.quick-view-button');

  quickViewButton.forEach((button) => {
    button.addEventListener('click', () => {
      console.log('clicked');
      alert('clicked');
    });
  });

  //  load more

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"]) return;
  try {
    
  fetch('https://restcountries.com/v3.1/all?fields=name')
    .then((response) => response.json())
    .then((countries) => {
      console.log(countries);
      const countrySelect = document.getElementById('country');
      countries.sort((a, b) => a.name.common.localeCompare(b.name.common));
      countries.forEach((country) => {
        const option = document.createElement('option');
        option.value = country.name.common;
        option.text = country.name.common;
        countrySelect.add(option);
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Accordion
  document.querySelectorAll('.accordion-button').forEach((button) => {
    button.addEventListener('click', () => {
      const isOpen = button.getAttribute('data-open') === 'true';
      const content = document.querySelector(`#${button.getAttribute('aria-controls')}`);
      const plusIcon = button.querySelector('.plus-icon');
      const minusIcon = button.querySelector('.minus-icon');

      content.classList.toggle('hidden');
      plusIcon.classList.toggle('hidden');
      minusIcon.classList.toggle('hidden');
      button.setAttribute('data-open', !isOpen);
    });
  });

  // Image selector
  document.querySelectorAll('.slider-image').forEach((image) => {
    image.addEventListener('click', () => {
      const mainImage = document.getElementById('main-image');
      mainImage.src = image.src;
    });
  });

  // spinner
  document.getElementById('add-to-cart').addEventListener('click', () => {
    const button = document.getElementById('add-to-cart');
    button.innerHTML = `<svg class="mx-auto h-5 w-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>`;
    setTimeout(() => {
      button.innerHTML = 'Add to cart'; // Replace this with the original button content
    }, 1000);
  });

  } catch(e) { console.error(e); }
})();
})();
